export default __webpack_public_path__ + "static/media/2.06e267c4.png";